import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';

@Component({
    selector: 'video-control-sound',
    template: `
        @if (!player.isMuted) {
            <i class="col-w fs-6 fs-4-s icon-unmute"></i>
        }
        @if (player.isMuted) {
            <i class="col-w fs-6 fs-4-s icon-mute"></i>
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoControlSoundComponent {
    @Input({ required: true })
    player!: VimeoPlayerComponent;

    @HostListener('click')
    onClick() {
        if (this.player) {
            if (this.player.isMuted) {
                this.player.unMute();
            } else {
                this.player.mute();
            }
        }
    }
}
